var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMobileScreen)?_c('footerNavMobile',{attrs:{"pageConfig":_vm.pageConfig}}):_c('footerNavPC',{attrs:{"pageConfig":_vm.pageConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }